"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseStatusTitleEnum = void 0;
var ExpenseStatusTitleEnum;
(function (ExpenseStatusTitleEnum) {
    ExpenseStatusTitleEnum["WAITING_APPROVAL"] = "Waiting Approval";
    ExpenseStatusTitleEnum["DOCUMENTS_NEEDED"] = "Documents Needed";
    ExpenseStatusTitleEnum["PURCHASE_PENDING"] = "Purchase approval pending";
    ExpenseStatusTitleEnum["DOCS_NEEDED"] = "Documents Needed";
    ExpenseStatusTitleEnum["INVOICE_PENDING"] = "Invoice approval pending";
    ExpenseStatusTitleEnum["APPROVED"] = "Approved";
    ExpenseStatusTitleEnum["DECLINED"] = "Declined";
    ExpenseStatusTitleEnum["REVIEWED"] = "Reviewed";
    ExpenseStatusTitleEnum["PAID"] = "Paid";
    ExpenseStatusTitleEnum["DONE"] = "Done";
})(ExpenseStatusTitleEnum || (exports.ExpenseStatusTitleEnum = ExpenseStatusTitleEnum = {}));
